'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/eval.js
// module id = 1373
// module chunks = 1